import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Package, Truck, Warehouse, CheckCircle } from 'lucide-react';

const LogisticsTracker = ({ logisticsData }) => {
  if (!logisticsData) {
    return <div>Загрузка...</div>;
  }

  const { total_items, ordered, in_transit, in_warehouse, installed } = logisticsData;

  const statusItems = [
    {
      label: 'Заказано',
      count: ordered,
      icon: Package,
      color: 'text-gray-600',
      bgColor: 'bg-gray-50',
      testId: 'logistics-ordered',
    },
    {
      label: 'В пути',
      count: in_transit,
      icon: Truck,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      testId: 'logistics-in-transit',
    },
    {
      label: 'На складе',
      count: in_warehouse,
      icon: Warehouse,
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-50',
      testId: 'logistics-warehouse',
    },
    {
      label: 'Смонтировано',
      count: installed,
      icon: CheckCircle,
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      testId: 'logistics-installed',
    },
  ];

  return (
    <Card data-testid="logistics-tracker-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <span>📦</span> Логистика
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="text-3xl font-bold" data-testid="total-items">
            {total_items} <span className="text-lg text-gray-500">позиций</span>
          </div>

          <div className="space-y-3">
            {statusItems.map((item) => {
              const Icon = item.icon;
              return (
                <div
                  key={item.label}
                  className={`flex items-center justify-between p-3 ${item.bgColor} rounded-lg`}
                  data-testid={item.testId}
                >
                  <div className="flex items-center gap-2">
                    <Icon className={`w-5 h-5 ${item.color}`} />
                    <span className="font-medium">{item.label}</span>
                  </div>
                  <span className={`text-2xl font-bold ${item.color}`}>{item.count}</span>
                </div>
              );
            })}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default LogisticsTracker;
